// import React, { useState, useEffect } from 'react';
// import { MapPin, Phone, Mail, ShoppingCart, Trash2, CreditCard, Smartphone } from 'lucide-react';

// const Logo = ({ className = "w-16 h-16" }) => (
//   <svg viewBox="0 0 120 120" className={className}>
//     <defs>
//       <linearGradient id="metalGradient" x1="0%" y1="0%" x2="100%" y2="100%">
//         <stop offset="0%" style={{ stopColor: '#C9A961', stopOpacity: 1 }} />
//         <stop offset="50%" style={{ stopColor: '#D4AF37', stopOpacity: 1 }} />
//         <stop offset="100%" style={{ stopColor: '#B8956A', stopOpacity: 1 }} />
//       </linearGradient>
//     </defs>
//     <text x="40" y="58" fontSize="68" fontWeight="900" fill="url(#metalGradient)" fontFamily="Georgia, serif" style={{ fontStyle: 'italic' }}>M</text>
//     <text x="55" y="92" fontSize="68" fontWeight="900" fill="url(#metalGradient)" fontFamily="Georgia, serif" style={{ fontStyle: 'italic' }}>S</text>
//     <circle cx="60" cy="60" r="58" fill="none" stroke="url(#metalGradient)" strokeWidth="2" opacity="0.3"/>
//   </svg>
// );

// const App = () => {
//   const [currentPage, setCurrentPage] = useState('home');
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [cart, setCart] = useState([]);
//   const [paymentMethod, setPaymentMethod] = useState('');
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [orders, setOrders] = useState([]);
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');

//   const heroSlides = [
//     {
//       title: "Uttrakhand Delicacy",
//       subtitle: "Traditional Himalayan Sweets",
//       image: "https://images.unsplash.com/photo-1606313564200-e75d5e30476c?w=1200&h=800&fit=crop",
//       color: "#8B5CF6"
//     },
//     {
//       title: "Now Taste The Authentic",
//       subtitle: "With Online Delivery Service",
//       image: "https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?w=1200&h=800&fit=crop",
//       color: "#EC4899"
//     },
//     {
//       title: "Serving Customers Since 1940",
//       subtitle: "Premium Balmithai & Traditional Sweets",
//       image: "https://images.unsplash.com/photo-1621303837174-89787a7d4729?w=1200&h=800&fit=crop",
//       color: "#10B981"
//     },
//     {
//       title: "Express Delivery",
//       subtitle: "Get Your Order in Less Than 4 Days",
//       image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=800&fit=crop",
//       color: "#F59E0B"
//     }
//   ];

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
//     }, 5000);
//     return () => clearInterval(timer);
//   }, []);

//   const addToCart = (item, quantity) => {
//     if (quantity > 0) {
//       setCart(prev => {
//         const existing = prev.find(i => i.name === item);
//         if (existing) {
//           return prev.map(i => i.name === item ? { ...i, quantity: i.quantity + quantity } : i);
//         }
//         return [...prev, { name: item, quantity, price: 440 }];
//       });
//     }
//   };

//   const removeFromCart = (itemName) => {
//     setCart(prev => prev.filter(item => item.name !== itemName));
//   };

//   const handleLogin = () => {
//     if (username === 'admin' && password === 'mamus@1940') {
//       setIsLoggedIn(true);
//       setCurrentPage('dashboard');
//     } else {
//       alert('Invalid credentials! Username: admin, Password: mamus@1940');
//     }
//   };

//   const handlePlaceOrder = () => {
//     if (cart.length > 0 && paymentMethod) {
//       const newOrder = {
//         id: Date.now(),
//         items: [...cart],
//         total: cart.reduce((sum, item) => sum + (item.quantity * item.price), 0) + 
//                (cart.reduce((sum, item) => sum + item.quantity, 0) * 100),
//         date: new Date().toLocaleString(),
//         paymentMethod: paymentMethod === 'scanner' ? 'Scanner QR Payment' : 'UPI ID Payment'
//       };
//       setOrders(prev => [newOrder, ...prev]);
//       alert(`Order placed successfully! Total: ₹${newOrder.total}\n\nPlease send payment screenshot on WhatsApp: 9027673285`);
//       setCart([]);
//       setPaymentMethod('');
//     }
//   };

//   const HomePage = () => {
//     const [isVisible, setIsVisible] = useState(false);
    
//     useEffect(() => {
//       setIsVisible(true);
//     }, []);

//     return (
//       <div className="min-h-screen bg-gradient-to-b from-purple-50 via-blue-50 to-orange-50">
//         <div className="relative h-screen overflow-hidden">
//           {heroSlides.map((slide, idx) => (
//             <div
//               key={idx}
//               className="absolute inset-0 transition-opacity duration-1000"
//               style={{
//                 opacity: currentSlide === idx ? 1 : 0,
//                 zIndex: currentSlide === idx ? 1 : 0
//               }}
//             >
//               <div 
//                 className="absolute inset-0 bg-cover bg-center"
//                 style={{
//                   backgroundImage: `url(${slide.image})`,
//                   filter: 'brightness(0.6)'
//                 }}
//               />
//               <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${slide.color}40 0%, ${slide.color}20 100%)` }} />
//               <div className="relative z-10 flex flex-col items-center justify-center h-full text-white px-4">
//                 <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-center mb-4 animate-fadeIn" style={{ color: slide.color, textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
//                   {slide.title}
//                 </h1>
//                 <p className="text-xl sm:text-2xl md:text-3xl text-center mb-8 animate-fadeIn">
//                   {slide.subtitle}
//                 </p>
//                 <button
//                   onClick={() => setCurrentPage('order')}
//                   className="bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full text-lg sm:text-xl transition-all transform hover:scale-105 shadow-2xl"
//                 >
//                   Order Now
//                 </button>
//               </div>
//             </div>
//           ))}
          
//           <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 z-20">
//             {heroSlides.map((_, idx) => (
//               <button
//                 key={idx}
//                 onClick={() => setCurrentSlide(idx)}
//                 className={`w-3 h-3 rounded-full transition-all ${
//                   currentSlide === idx ? 'bg-white w-8' : 'bg-white bg-opacity-50'
//                 }`}
//               />
//             ))}
//           </div>
//         </div>

//         <div className="py-16 sm:py-20 px-4 bg-gradient-to-r from-purple-100 via-blue-100 to-orange-100">
//           <div className="max-w-7xl mx-auto">
//             <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
//               <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-center mb-4 text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>
//                 Mero Pahad
//               </h2>
//               <p className="text-center text-lg sm:text-xl text-gray-700 mb-12 max-w-3xl mx-auto">
//                 The Sweet Heritage of Uttarakhand Mountains
//               </p>
//             </div>
            
//             <div className="grid md:grid-cols-2 gap-8 mb-12">
//               <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500 hover:shadow-purple-300 relative">
//                 <img 
//                   src="https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=800&h=600&fit=crop" 
//                   alt="Uttarakhand Mountains"
//                   className="w-full h-64 sm:h-80 object-cover hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-purple-900 via-transparent to-transparent opacity-0 hover:opacity-70 transition-opacity duration-500 flex items-end p-6">
//                   <p className="text-white font-bold text-xl">Majestic Himalayas</p>
//                 </div>
//               </div>
//               <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500 hover:shadow-blue-300 relative">
//                 <img 
//                   src="https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=800&h=600&fit=crop" 
//                   alt="Nainital Lake"
//                   className="w-full h-64 sm:h-80 object-cover hover:scale-110 transition-transform duration-700"
//                 />
//                 <div className="absolute inset-0 bg-gradient-to-t from-blue-900 via-transparent to-transparent opacity-0 hover:opacity-70 transition-opacity duration-500 flex items-end p-6">
//                   <p className="text-white font-bold text-xl">Serene Nainital</p>
//                 </div>
//               </div>
//             </div>

//             <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-2xl p-6 sm:p-10 hover:shadow-purple-200 transition-shadow duration-500">
//               <p className="text-base sm:text-lg text-gray-800 leading-relaxed mb-6">
//                 Nestled in the serene valleys of Uttarakhand, our sweets carry the essence of the mighty Himalayas. <strong className="text-purple-700">Balmithai</strong>, the crown jewel of Kumaoni cuisine, is a delicate sweet made with pure khoya and desi ghee, wrapped in a crispy outer layer that melts in your mouth.
//               </p>
//               <p className="text-base sm:text-lg text-gray-800 leading-relaxed mb-6">
//                 <strong className="text-blue-700">Singori</strong>, another treasure from these mountains, is a traditional sweet wrapped in maalu leaves, filled with khoya and coconut - a taste that transports you to the pine forests of Uttarakhand.
//               </p>
//               <p className="text-base sm:text-lg text-gray-800 leading-relaxed">
//                 Our handcrafted <strong className="text-orange-700">chocolates</strong> blend the richness of traditional methods with contemporary flavors, creating a unique fusion that honors our heritage while embracing innovation.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-gradient-to-r from-orange-400 to-purple-500 text-white py-12 sm:py-16 px-4">
//           <div className="max-w-6xl mx-auto">
//             <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
//               <div className="bg-white bg-opacity-20 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl transform hover:scale-105 transition-transform">
//                 <Phone className="w-10 h-10 sm:w-12 sm:h-12 mb-4 mx-auto" />
//                 <h3 className="text-lg sm:text-xl font-bold mb-2 text-center">Call Us</h3>
//                 <p className="text-base sm:text-lg text-center">9027673111</p>
//                 <p className="text-xs sm:text-sm text-center mt-2 opacity-90">Mon-Sat: 9AM-8PM</p>
//               </div>
//               <div className="bg-white bg-opacity-20 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl transform hover:scale-105 transition-transform">
//                 <Mail className="w-10 h-10 sm:w-12 sm:h-12 mb-4 mx-auto" />
//                 <h3 className="text-lg sm:text-xl font-bold mb-2 text-center">Email Us</h3>
//                 <p className="text-sm sm:text-base text-center break-all">mamussweet@gmail.com</p>
//                 <p className="text-xs sm:text-sm text-center mt-2 opacity-90">Quick Response</p>
//               </div>
//               <div className="bg-white bg-opacity-20 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl transform hover:scale-105 transition-transform">
//                 <MapPin className="w-10 h-10 sm:w-12 sm:h-12 mb-4 mx-auto" />
//                 <h3 className="text-lg sm:text-xl font-bold mb-2 text-center">Visit Us</h3>
//                 <p className="text-base sm:text-lg text-center">Nainital</p>
//                 <p className="text-sm sm:text-base text-center">Uttarakhand, India</p>
//                 <a 
//                   href="https://maps.app.goo.gl/9U4LHWDNCbwgyE9f8" 
//                   target="_blank" 
//                   rel="noopener noreferrer"
//                   className="inline-block mt-3 bg-white text-purple-700 px-4 py-2 rounded-full font-semibold hover:bg-purple-100 transition-colors text-sm"
//                 >
//                   View Map
//                 </a>
//               </div>
//               <div className="bg-white bg-opacity-20 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl transform hover:scale-105 transition-transform">
//                 <ShoppingCart className="w-10 h-10 sm:w-12 sm:h-12 mb-4 mx-auto" />
//                 <h3 className="text-lg sm:text-xl font-bold mb-2 text-center">Express Delivery</h3>
//                 <p className="text-base sm:text-lg text-center">Pan India</p>
//                 <p className="text-xs sm:text-sm text-center mt-2 opacity-90">Within 4 Days</p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const AboutPage = () => {
//     return (
//       <div className="min-h-screen bg-gradient-to-b from-purple-50 via-blue-50 to-orange-50 py-12 sm:py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-center mb-12 sm:mb-16 text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
//             About Us
//           </h1>
//           <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center mb-12 sm:mb-16">
//             <div className="rounded-2xl overflow-hidden shadow-2xl order-2 md:order-1">
//               <img 
//                 src="https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=800&h=600&fit=crop"
//                 alt="Nainital Lake"
//                 className="w-full h-64 sm:h-96 object-cover"
//               />
//             </div>
//             <div className="space-y-4 sm:space-y-6 order-1 md:order-2">
//               <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
//                 <strong className="text-2xl sm:text-3xl text-purple-800" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Mamu's Sweet House</strong> has been a cornerstone of Uttarakhand's culinary heritage since <strong>1940</strong>. For over eight decades, we have been crafting authentic traditional sweets.
//               </p>
//               <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
//                 Our journey began in the picturesque hills of Nainital, where our founder started with a simple vision: to preserve and share the authentic taste of Uttarakhand sweets with the world.
//               </p>
//             </div>
//           </div>

//           <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
//             <div className="bg-white bg-opacity-70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl">
//               <h3 className="text-xl sm:text-2xl font-bold text-orange-700 mb-4">Our Specialties</h3>
//               <ul className="space-y-2 text-gray-700 text-sm sm:text-base">
//                 <li className="flex items-start">
//                   <span className="text-orange-500 mr-2 text-lg">•</span>
//                   <span>Authentic Balmithai made with pure desi ghee</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="text-orange-500 mr-2 text-lg">•</span>
//                   <span>Traditional Singori wrapped in maalu leaves</span>
//                 </li>
//                 <li className="flex items-start">
//                   <span className="text-orange-500 mr-2 text-lg">•</span>
//                   <span>Handcrafted Uttarakhand chocolates</span>
//                 </li>
//               </ul>
//             </div>

//             <div className="bg-white bg-opacity-70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl">
//               <h3 className="text-xl sm:text-2xl font-bold text-purple-700 mb-4">Our Promise</h3>
//               <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
//                 We use only the finest ingredients sourced locally from Uttarakhand. Every sweet is prepared using traditional methods and pure desi ghee.
//               </p>
//             </div>

//             <div className="bg-white bg-opacity-70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl">
//               <h3 className="text-xl sm:text-2xl font-bold text-blue-700 mb-4">Our Reputation</h3>
//               <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
//                 Known throughout Uttarakhand and beyond, Mamu's Sweet House has earned a respected name for quality, authenticity, and exceptional taste.
//               </p>
//             </div>
//           </div>

//           <div className="bg-gradient-to-r from-purple-200 to-orange-200 p-8 sm:p-10 rounded-3xl shadow-2xl text-center">
//             <h3 className="text-2xl sm:text-3xl font-bold text-purple-900 mb-4">
//               Experience the Taste of Tradition
//             </h3>
//             <p className="text-lg sm:text-xl text-gray-700 mb-6">
//               From the heart of the Himalayas to your doorstep
//             </p>
//             <button
//               onClick={() => setCurrentPage('order')}
//               className="bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-all transform hover:scale-105 shadow-xl"
//             >
//               Order Now
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const OrderPage = () => {
//     const [tempQuantity, setTempQuantity] = useState({ balmithai: 0, chocolate: 0 });
//     const pricePerKg = 440;
//     const deliveryChargePerKg = 100;
    
//     const cartTotal = cart.reduce((sum, item) => sum + (item.quantity * item.price), 0);
//     const totalKg = cart.reduce((sum, item) => sum + item.quantity, 0);
//     const deliveryCharges = totalKg * deliveryChargePerKg;
//     const total = cartTotal + deliveryCharges;

//     return (
//       <div className="min-h-screen bg-gradient-to-b from-purple-50 via-blue-50 to-orange-50 py-12 sm:py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <h1 className="text-4xl sm:text-5xl font-bold text-center mb-8 sm:mb-12 text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
//             Place Your Order
//           </h1>
          
//           <div className="grid lg:grid-cols-3 gap-6 sm:gap-8">
//             <div className="lg:col-span-2 space-y-6">
//               <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 sm:p-8">
//                 <h2 className="text-2xl sm:text-3xl font-bold text-orange-800 mb-6">Our Products</h2>
                
//                 <div className="space-y-6">
//                   <div className="bg-gradient-to-r from-orange-100 to-purple-100 p-4 sm:p-6 rounded-2xl shadow-lg">
//                     <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//                       <div className="flex-1">
//                         <h3 className="text-xl sm:text-2xl font-bold text-purple-900">Balmithai</h3>
//                         <p className="text-gray-600 text-sm sm:text-base">Traditional Kumaoni delicacy</p>
//                         <p className="text-lg sm:text-xl font-bold text-orange-600 mt-2">₹{pricePerKg}/kg</p>
//                       </div>
//                       <div className="flex items-center gap-3 sm:gap-4">
//                         <button
//                           onClick={() => setTempQuantity(prev => ({ ...prev, balmithai: Math.max(0, prev.balmithai - 0.5) }))}
//                           className="bg-purple-500 text-white w-10 h-10 rounded-full font-bold hover:bg-purple-600 shadow-lg"
//                         >
//                           -
//                         </button>
//                         <span className="text-xl sm:text-2xl font-bold w-16 sm:w-20 text-center">{tempQuantity.balmithai} kg</span>
//                         <button
//                           onClick={() => setTempQuantity(prev => ({ ...prev, balmithai: prev.balmithai + 0.5 }))}
//                           className="bg-purple-500 text-white w-10 h-10 rounded-full font-bold hover:bg-purple-600 shadow-lg"
//                         >
//                           +
//                         </button>
//                         <button
//                           onClick={() => {
//                             addToCart('Balmithai', tempQuantity.balmithai);
//                             setTempQuantity(prev => ({ ...prev, balmithai: 0 }));
//                           }}
//                           className="bg-orange-500 hover:bg-orange-600 text-white px-4 sm:px-6 py-2 rounded-full font-bold shadow-lg ml-2"
//                         >
//                           Add
//                         </button>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="bg-gradient-to-r from-purple-100 to-orange-100 p-4 sm:p-6 rounded-2xl shadow-lg">
//                     <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
//                       <div className="flex-1">
//                         <h3 className="text-xl sm:text-2xl font-bold text-purple-900">Chocolate</h3>
//                         <p className="text-gray-600 text-sm sm:text-base">Handcrafted Uttarakhand style</p>
//                         <p className="text-lg sm:text-xl font-bold text-orange-600 mt-2">₹{pricePerKg}/kg</p>
//                       </div>
//                       <div className="flex items-center gap-3 sm:gap-4">
//                         <button
//                           onClick={() => setTempQuantity(prev => ({ ...prev, chocolate: Math.max(0, prev.chocolate - 0.5) }))}
//                           className="bg-purple-500 text-white w-10 h-10 rounded-full font-bold hover:bg-purple-600 shadow-lg"
//                         >
//                           -
//                         </button>
//                         <span className="text-xl sm:text-2xl font-bold w-16 sm:w-20 text-center">{tempQuantity.chocolate} kg</span>
//                         <button
//                           onClick={() => setTempQuantity(prev => ({ ...prev, chocolate: prev.chocolate + 0.5 }))}
//                           className="bg-purple-500 text-white w-10 h-10 rounded-full font-bold hover:bg-purple-600 shadow-lg"
//                         >
//                           +
//                         </button>
//                         <button
//                           onClick={() => {
//                             addToCart('Chocolate', tempQuantity.chocolate);
//                             setTempQuantity(prev => ({ ...prev, chocolate: 0 }));
//                           }}
//                           className="bg-orange-500 hover:bg-orange-600 text-white px-4 sm:px-6 py-2 rounded-full font-bold shadow-lg ml-2"
//                         >
//                           Add
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {cart.length > 0 && (
//                 <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 sm:p-8">
//                   <h2 className="text-2xl sm:text-3xl font-bold text-purple-800 mb-6 flex items-center">
//                     <ShoppingCart className="mr-3" /> Your Cart
//                   </h2>
//                   <div className="space-y-4">
//                     {cart.map((item, idx) => (
//                       <div key={idx} className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-gradient-to-r from-purple-50 to-orange-50 p-4 rounded-xl gap-4">
//                         <div className="flex-1">
//                           <h3 className="text-lg sm:text-xl font-bold text-gray-800">{item.name}</h3>
//                           <p className="text-gray-600 text-sm sm:text-base">{item.quantity} kg × ₹{item.price}</p>
//                         </div>
//                         <div className="flex items-center gap-3">
//                           <span className="text-lg sm:text-xl font-bold text-orange-600">₹{item.quantity * item.price}</span>
//                           <button
//                             onClick={() => removeFromCart(item.name)}
//                             className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-full shadow-lg"
//                           >
//                             <Trash2 className="w-4 h-4 sm:w-5 sm:h-5" />
//                           </button>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>

//             <div className="lg:col-span-1">
//               <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 sm:p-8 sticky top-24">
//                 <h2 className="text-2xl sm:text-3xl font-bold text-purple-800 mb-6">Order Summary</h2>
//                 <div className="space-y-4 text-base sm:text-lg">
//                   <div className="flex justify-between py-2 border-b border-gray-300">
//                     <span className="text-gray-700">Subtotal:</span>
//                     <span className="font-bold">₹{cartTotal}</span>
//                   </div>
//                   <div className="flex justify-between py-2 border-b border-gray-300">
//                     <span className="text-gray-700">Delivery ({totalKg} kg):</span>
//                     <span className="font-bold">₹{deliveryCharges}</span>
//                   </div>
//                   <div className="flex justify-between py-3 text-xl sm:text-2xl font-bold text-purple-900 border-t-2 border-purple-300">
//                     <span>Total:</span>
//                     <span>₹{total}</span>
//                   </div>
//                 </div>

//                 {cart.length > 0 && (
//                   <div className="mt-8">
//                     <h3 className="text-lg sm:text-xl font-bold text-purple-800 mb-4">Payment Method</h3>
//                     <div className="space-y-3">
//                       <button
//                         onClick={() => setPaymentMethod('scanner')}
//                         className={`w-full p-4 rounded-xl border-2 transition-all ${
//                           paymentMethod === 'scanner' 
//                             ? 'border-purple-500 bg-purple-100' 
//                             : 'border-gray-300 bg-white hover:border-purple-300'
//                         }`}
//                       >
//                         <div className="flex items-center justify-between">
//                           <div className="flex items-center">
//                             <CreditCard className="w-6 h-6 mr-3 text-purple-600" />
//                             <span className="font-semibold text-gray-800">Scanner Pay (QR Code)</span>
//                           </div>
//                           <div className={`w-5 h-5 rounded-full border-2 ${
//                             paymentMethod === 'scanner' ? 'border-purple-500 bg-purple-500' : 'border-gray-300'
//                           }`}>
//                             {paymentMethod === 'scanner' && (
//                               <div className="w-full h-full flex items-center justify-center text-white text-xs">✓</div>
//                             )}
//                           </div>
//                         </div>
//                       </button>

//                       <button
//                         onClick={() => setPaymentMethod('upi')}
//                         className={`w-full p-4 rounded-xl border-2 transition-all ${
//                           paymentMethod === 'upi' 
//                             ? 'border-purple-500 bg-purple-100' 
//                             : 'border-gray-300 bg-white hover:border-purple-300'
//                         }`}
//                       >
//                         <div className="flex items-center justify-between">
//                           <div className="flex items-center">
//                             <Smartphone className="w-6 h-6 mr-3 text-purple-600" />
//                             <span className="font-semibold text-gray-800">UPI ID Payment</span>
//                           </div>
//                           <div className={`w-5 h-5 rounded-full border-2 ${
//                             paymentMethod === 'upi' ? 'border-purple-500 bg-purple-500' : 'border-gray-300'
//                           }`}>
//                             {paymentMethod === 'upi' && (
//                               <div className="w-full h-full flex items-center justify-center text-white text-xs">✓</div>
//                             )}
//                           </div>
//                         </div>
//                       </button>
//                     </div>

//                     {paymentMethod === 'scanner' && (
//                       <div className="mt-6 bg-gradient-to-br from-purple-50 to-orange-50 p-6 rounded-2xl border-2 border-purple-200">
//                         <h4 className="font-bold text-center mb-4 text-purple-900 text-lg">Scan QR Code to Pay</h4>
//                         <div className="bg-white p-4 rounded-xl mb-4 flex justify-center shadow-lg">
//                           <img 
//                             src="https://i.postimg.cc/rFDN8HLX/qr-code.png" 
//                             alt="UPI QR Code" 
//                             className="w-64 h-64 object-contain"
//                             onError={(e) => {
//                               e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='256' height='256'%3E%3Crect width='256' height='256' fill='%23f0f0f0'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999' font-size='16'%3EQRCODE%3C/text%3E%3C/svg%3E";
//                             }}
//                           />
//                         </div>
//                         <div className="bg-purple-100 p-4 rounded-xl mb-4 text-center border-2 border-purple-300">
//                           <p className="text-sm text-gray-700 font-semibold mb-2">Amount to Pay:</p>
//                           <p className="text-3xl font-bold text-purple-900">₹{total}</p>
//                         </div>
//                         <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 rounded">
//                           <p className="text-sm text-gray-800 font-semibold mb-2">📸 Important Note:</p>
//                           <p className="text-sm text-gray-700 mb-2">After payment, please send screenshot on WhatsApp:</p>
//                           <a 
//                             href="https://wa.me/919027673285" 
//                             target="_blank" 
//                             rel="noopener noreferrer"
//                             className="inline-block bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition-colors"
//                           >
//                             📱 WhatsApp: +91 9027673285
//                           </a>
//                         </div>
//                       </div>
//                     )}

//                     {paymentMethod === 'upi' && (
//                       <div className="mt-6 bg-gradient-to-br from-purple-50 to-orange-50 p-6 rounded-2xl border-2 border-purple-200">
//                         <h4 className="font-bold text-center mb-4 text-purple-900 text-lg">Pay via UPI ID</h4>
//                         <div className="bg-white p-4 rounded-xl mb-4 shadow-lg">
//                           <p className="text-center font-mono text-xl text-purple-900 mb-3 font-bold">vanshsingh0491@okaxis</p>
//                           <button
//                             onClick={() => {
//                               navigator.clipboard.writeText('vanshsingh0491@okaxis');
//                               alert('UPI ID copied to clipboard!');
//                             }}
//                             className="w-full bg-purple-500 hover:bg-purple-600 text-white py-3 rounded-lg text-base font-semibold transition-colors"
//                           >
//                             📋 Copy UPI ID
//                           </button>
//                         </div>
//                         <div className="bg-purple-100 p-4 rounded-xl mb-4 text-center border-2 border-purple-300">
//                           <p className="text-sm text-gray-700 font-semibold mb-2">Amount to Pay:</p>
//                           <p className="text-3xl font-bold text-purple-900">₹{total}</p>
//                         </div>
//                         <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 rounded">
//                           <p className="text-sm text-gray-800 font-semibold mb-2">📸 Important Note:</p>
//                           <p className="text-sm text-gray-700 mb-2">After payment, please send screenshot on WhatsApp:</p>
//                           <a 
//                             href="https://wa.me/919027673285" 
//                             target="_blank" 
//                             rel="noopener noreferrer"
//                             className="inline-block bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-lg transition-colors"
//                           >
//                             📱 WhatsApp: +91 9027673285
//                           </a>
//                         </div>
//                       </div>
//                     )}

//                     <button
//                       disabled={!paymentMethod || cart.length === 0}
//                       onClick={handlePlaceOrder}
//                       className={`w-full mt-6 font-bold py-4 px-8 rounded-full text-lg transition-all transform shadow-xl ${
//                         paymentMethod && cart.length > 0
//                           ? 'bg-gradient-to-r from-orange-400 to-purple-500 hover:from-orange-500 hover:to-purple-600 text-white hover:scale-105 hover:shadow-2xl'
//                           : 'bg-gray-300 text-gray-500 cursor-not-allowed'
//                       }`}
//                     >
//                       {cart.length === 0 ? 'Add Items to Cart' : !paymentMethod ? 'Select Payment Method' : 'Confirm Order'}
//                     </button>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const AdminLogin = () => {
//     return (
//       <div className="min-h-screen bg-gradient-to-b from-orange-50 via-blue-50 to-purple-50 py-20 px-4">
//         <div className="max-w-md mx-auto">
//           <div className="bg-white bg-opacity-80 backdrop-blur-sm rounded-3xl shadow-2xl p-8 sm:p-10">
//             <div className="flex justify-center mb-6">
//               <Logo className="w-24 h-24" />
//             </div>
//             <h1 className="text-3xl sm:text-4xl font-bold text-center mb-8 text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Admin Login</h1>
//             <div className="space-y-6">
//               <div>
//                 <label className="block text-gray-700 font-bold mb-2 text-lg">Username</label>
//                 <input
//                   type="text"
//                   value={username}
//                   onChange={(e) => setUsername(e.target.value)}
//                   className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:outline-none bg-white"
//                   placeholder="Enter username"
//                 />
//               </div>
//               <div>
//                 <label className="block text-gray-700 font-bold mb-2 text-lg">Password</label>
//                 <input
//                   type="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   onKeyPress={(e) => e.key === 'Enter' && handleLogin()}
//                   className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:outline-none bg-white"
//                   placeholder="Enter password"
//                 />
//               </div>
//               <button
//                 onClick={handleLogin}
//                 className="w-full bg-gradient-to-r from-orange-400 to-purple-500 hover:from-orange-500 hover:to-purple-600 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 shadow-xl text-lg"
//               >
//                 Login
//               </button>
//               <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 mt-4">
//                 <p className="text-sm text-gray-700 text-center">
//                   <strong className="text-blue-900">Default Login:</strong><br/>
//                   Username: <span className="font-mono bg-white px-2 py-1 rounded">admin</span><br/>
//                   Password: <span className="font-mono bg-white px-2 py-1 rounded">mamus@1940</span>
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };
//   const handlePayment = async () => {
//   const res = await fetch("http://localhost:5000/api/payment/create-order", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ amount: 500 }),
//   });

//   const order = await res.json();

//   const options = {
//     key: "rzp_test_xxxxx", // same as ENV
//     amount: order.amount,
//     currency: "INR",
//     name: "Mamu Sweet House",
//     description: "Order Payment",
//     order_id: order.id,

//     handler: function (response) {
//       alert("Payment Success ✅");
//       console.log(response);
//     },
//   };

//   const rzp = new window.Razorpay(options);
//   rzp.open();
// };
//   const AdminDashboard = () => {
//     return (
//       <div className="min-h-screen bg-gradient-to-b from-purple-50 via-blue-50 to-orange-50 py-12 sm:py-20 px-4">
//         <div className="max-w-7xl mx-auto">
//           <div className="flex justify-between items-center mb-8">
//             <h1 className="text-4xl sm:text-5xl font-bold text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
//               Admin Dashboard
//             </h1>
//             <button
//               onClick={() => {
//                 setIsLoggedIn(false);
//                 setCurrentPage('home');
//                 setUsername('');
//                 setPassword('');
//               }}
//               className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-full font-semibold transition-all shadow-lg"
//             >
//               Logout
//             </button>
//           </div>

//           <div className="grid md:grid-cols-3 gap-6 mb-8">
//             <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 border-2 border-purple-200">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-gray-600 text-sm font-semibold">Total Orders</p>
//                   <p className="text-4xl font-bold text-purple-900">{orders.length}</p>
//                 </div>
//                 <ShoppingCart className="w-12 h-12 text-purple-500" />
//               </div>
//             </div>

//             <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 border-2 border-orange-200">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-gray-600 text-sm font-semibold">Recent Orders (Today)</p>
//                   <p className="text-4xl font-bold text-orange-900">
//                     {orders.filter(o => {
//                       const orderDate = new Date(o.date);
//                       const today = new Date();
//                       return orderDate.toDateString() === today.toDateString();
//                     }).length}
//                   </p>
//                 </div>
//                 <Mail className="w-12 h-12 text-orange-500" />
//               </div>
//             </div>

//             <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 border-2 border-green-200">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-gray-600 text-sm font-semibold">Total Revenue</p>
//                   <p className="text-3xl font-bold text-green-900">
//                     ₹{orders.reduce((sum, order) => sum + order.total, 0)}
//                   </p>
//                 </div>
//                 <CreditCard className="w-12 h-12 text-green-500" />
//               </div>
//             </div>
//           </div>

//           <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 sm:p-8 border-2 border-purple-200">
//             <h2 className="text-2xl sm:text-3xl font-bold text-purple-800 mb-6">Recent Orders</h2>
//             {orders.length === 0 ? (
//               <div className="text-center py-12">
//                 <ShoppingCart className="w-16 h-16 mx-auto text-gray-400 mb-4" />
//                 <p className="text-xl text-gray-600 font-semibold">No orders yet</p>
//                 <p className="text-gray-500 mt-2">Orders will appear here once customers place them</p>
//               </div>
//             ) : (
//               <div className="space-y-4">
//                 {orders.map((order) => (
//                   <div key={order.id} className="bg-gradient-to-r from-purple-50 to-orange-50 p-6 rounded-2xl border-2 border-purple-200 shadow-md">
//                     <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
//                       <div>
//                         <p className="text-sm text-gray-600 font-semibold">Order ID: #{order.id}</p>
//                         <p className="text-sm text-gray-600">{order.date}</p>
//                       </div>
//                       <div className="text-right">
//                         <p className="text-2xl font-bold text-purple-900">₹{order.total}</p>
//                         <p className="text-sm text-gray-600 font-semibold">{order.paymentMethod}</p>
//                       </div>
//                     </div>
//                     <div className="border-t-2 border-purple-300 pt-4">
//                       <p className="font-semibold text-gray-700 mb-2">Items:</p>
//                       {order.items.map((item, idx) => (
//                         <div key={idx} className="flex justify-between items-center py-1">
//                           <span className="text-gray-700">{item.name} ({item.quantity} kg)</span>
//                           <span className="font-semibold text-gray-800">₹{item.quantity * item.price}</span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-white">
//       <header className="bg-white shadow-lg sticky top-0 z-50 border-b-2 border-purple-200 backdrop-blur-md bg-opacity-95">
//         <div className="max-w-7xl mx-auto px-4 py-4">
//           <div className="flex items-center justify-between">
//             <div className="flex gap-4 sm:gap-6 flex-1">
//               <button
//                 onClick={() => setCurrentPage('order')}
//                 className="text-gray-700 hover:text-orange-600 font-semibold transition-all duration-300 text-sm sm:text-base relative group"
//               >
//                 Place Order
//                 <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-600 group-hover:w-full transition-all duration-300"></span>
//               </button>
//               <button
//                 onClick={() => setCurrentPage('about')}
//                 className="text-gray-700 hover:text-purple-600 font-semibold transition-all duration-300 text-sm sm:text-base relative group"
//               >
//                 About Us
//                 <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-600 group-hover:w-full transition-all duration-300"></span>
//               </button>
//             </div>

//             <div
//               onClick={() => setCurrentPage('home')}
//               className="flex items-center gap-2 sm:gap-3 cursor-pointer transform hover:scale-105 transition-transform duration-300"
//             >
//               <Logo className="w-12 h-12 sm:w-16 sm:h-16" />
//               <span className="text-xl sm:text-2xl md:text-3xl font-bold text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
//                 Mamu's Sweet House
//               </span>
//             </div>

//             <div className="flex gap-4 sm:gap-6 flex-1 justify-end">
//               <button
//                 onClick={() => setCurrentPage('home')}
//                 className={`font-semibold transition-all duration-300 text-sm sm:text-base relative group ${
//                   currentPage === 'home' ? 'text-orange-600' : 'text-gray-700 hover:text-orange-600'
//                 }`}
//               >
//                 Home
//                 <span className={`absolute bottom-0 left-0 h-0.5 bg-orange-600 transition-all duration-300 ${
//                   currentPage === 'home' ? 'w-full' : 'w-0 group-hover:w-full'
//                 }`}></span>
//               </button>
//               <button
//                 onClick={() => setCurrentPage('admin')}
//                 className="text-gray-700 hover:text-purple-600 font-semibold transition-all duration-300 text-sm sm:text-base relative group"
//               >
//                 Admin
//                 <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-600 group-hover:w-full transition-all duration-300"></span>
//               </button>
//             </div>
//           </div>
//         </div>
//       </header>

//       {currentPage === 'home' && <HomePage />}
//       {currentPage === 'about' && <AboutPage />}
//       {currentPage === 'order' && <OrderPage />}
//       {currentPage === 'admin' && !isLoggedIn && <AdminLogin />}
//       {currentPage === 'dashboard' && isLoggedIn && <AdminDashboard />}

//       <footer className="bg-gradient-to-r from-purple-900 to-orange-800 text-white py-8 px-4">
//         <div className="max-w-6xl mx-auto text-center">
//           <div className="flex items-center justify-center gap-3 mb-4">
//             <Logo className="w-12 h-12" />
//             <span className="text-2xl font-bold" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
//               Mamu's Sweet House
//             </span>
//           </div>
//           <p className="text-lg mb-2">Traditional Uttarakhand Sweets Since 1940</p>
//           <p className="text-sm opacity-80">© 2024 Mamu's Sweet House. All rights reserved.</p>
//         </div>
//       </footer>

//       <style>{`
//         @keyframes fadeIn {
//           from {
//             opacity: 0;
//             transform: translateY(20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }
//         .animate-fadeIn {
//           animation: fadeIn 1s ease-out;
//         }
        
//         input:focus {
//           box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1);
//         }
        
//         button:active {
//           transform: scale(0.97);
//         }
//       `}</style>
//     </div>
//   );
// };

// export default App;
import React, { useState, useEffect , useRef } from 'react';
import { MapPin, Phone, Mail, ShoppingCart, Trash2, CreditCard } from 'lucide-react';

const BACKEND_URL = 'https://shop-backend-lpma.onrender.com';

const Logo = ({ className = "w-16 h-16" }) => (
  <svg viewBox="0 0 120 120" className={className}>
    <defs>
      <linearGradient id="metalGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#C9A961', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#D4AF37', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#B8956A', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <text x="40" y="58" fontSize="68" fontWeight="900" fill="url(#metalGradient)" fontFamily="Georgia, serif" style={{ fontStyle: 'italic' }}>M</text>
    <text x="55" y="92" fontSize="68" fontWeight="900" fill="url(#metalGradient)" fontFamily="Georgia, serif" style={{ fontStyle: 'italic' }}>S</text>
    <circle cx="60" cy="60" r="58" fill="none" stroke="url(#metalGradient)" strokeWidth="2" opacity="0.3"/>
  </svg>
);
// ─────────────────────────────────────────────────────────────────────────────
// DROP-IN REPLACEMENT: Cut everything between the AdminLogin const and the
// closing semicolon in your App.jsx, and replace with the export at the bottom.
//
// ALSO: Move AdminLogin OUTSIDE the App() function entirely.
// Place it just above the `const App = () => {` line.
// Pass these props from App: { username, setUsername, password, setPassword, handleLogin }
// ─────────────────────────────────────────────────────────────────────────────

// import React, { useState, useEffect, useRef } from 'react';

// ── Paste this block ABOVE `const App = () => {` ─────────────────────────────

const ADMIN_MAX_ATTEMPTS = 5;
const LOCKOUT_DURATION_MS = 15 * 60 * 1000; // 15 minutes

const AdminLogin = ({ username, setUsername, password, setPassword, handleLogin }) => {
  const [attempts, setAttempts]       = useState(0);
  const [lockedUntil, setLockedUntil] = useState(null);
  const [remaining, setRemaining]     = useState(0);
  const [shake, setShake]             = useState(false);
  const [capsLock, setCapsLock]       = useState(false);
  const [showPass, setShowPass]       = useState(false);
  const [focused, setFocused]         = useState('');
  const usernameRef                   = useRef(null);
  const passwordRef                   = useRef(null);

  // Countdown timer for lockout
  useEffect(() => {
    if (!lockedUntil) return;
    const interval = setInterval(() => {
      const left = lockedUntil - Date.now();
      if (left <= 0) { setLockedUntil(null); setAttempts(0); setRemaining(0); clearInterval(interval); }
      else setRemaining(Math.ceil(left / 1000));
    }, 500);
    return () => clearInterval(interval);
  }, [lockedUntil]);

  const isLocked = lockedUntil && Date.now() < lockedUntil;

  const onSubmit = () => {
    if (isLocked) return;
    if (username === 'admin' && password === 'mamus@1940') {
      handleLogin();
    } else {
      const next = attempts + 1;
      setAttempts(next);
      setShake(true);
      setTimeout(() => setShake(false), 600);
      if (next >= ADMIN_MAX_ATTEMPTS) {
        setLockedUntil(Date.now() + LOCKOUT_DURATION_MS);
      }
    }
  };

  const onKeyDown = (e) => {
    setCapsLock(e.getModifierState('CapsLock'));
    if (e.key === 'Enter') onSubmit();
  };

  const attemptsLeft = ADMIN_MAX_ATTEMPTS - attempts;

  return (
    <div className="min-h-screen flex items-center justify-center px-4 relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)' }}>

      {/* Animated background grid */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'linear-gradient(rgba(139,92,246,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(139,92,246,0.4) 1px, transparent 1px)',
        backgroundSize: '40px 40px'
      }} />

      {/* Glowing orbs */}
      <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full opacity-20 blur-3xl"
        style={{ background: 'radial-gradient(circle, #7C3AED, transparent)' }} />
      <div className="absolute bottom-1/4 right-1/4 w-48 h-48 rounded-full opacity-15 blur-3xl"
        style={{ background: 'radial-gradient(circle, #F97316, transparent)' }} />

      <div className="relative z-10 w-full max-w-md">
        {/* Card */}
        <div className={`rounded-2xl border border-purple-500 border-opacity-30 overflow-hidden ${shake ? 'animate-shake' : ''}`}
          style={{ background: 'rgba(15, 12, 41, 0.85)', backdropFilter: 'blur(20px)', boxShadow: '0 0 60px rgba(124,58,237,0.2), 0 25px 50px rgba(0,0,0,0.5)' }}>

          {/* Top accent bar */}
          <div className="h-1 w-full" style={{ background: 'linear-gradient(90deg, #7C3AED, #F97316, #7C3AED)', backgroundSize: '200% 100%' }} />

          <div className="p-8 sm:p-10">
            {/* Header */}
            <div className="text-center mb-10">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 border border-purple-500 border-opacity-40"
                style={{ background: 'rgba(124,58,237,0.15)' }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
                </svg>
              </div>
              <h1 className="text-2xl font-bold tracking-tight text-white mb-1" style={{ fontFamily: 'Georgia, serif' }}>
                Admin Portal
              </h1>
              <p className="text-sm text-purple-300 opacity-70">Mamu's Sweet House · Restricted Access</p>
            </div>

            {/* Lockout banner */}
            {isLocked && (
              <div className="mb-6 rounded-xl p-4 border border-red-500 border-opacity-40 flex items-start gap-3"
                style={{ background: 'rgba(239,68,68,0.1)' }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" viewBox="0 0 24 24" fill="currentColor">
                  <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3A5.25 5.25 0 0012 1.5zm-1.5 14.25a1.5 1.5 0 113 0v1.5a1.5 1.5 0 01-3 0v-1.5zm1.5-9a3.75 3.75 0 00-3.75 3.75v3h7.5v-3A3.75 3.75 0 0012 6.75z" clipRule="evenodd" />
                </svg>
                <div>
                  <p className="text-red-400 font-semibold text-sm">Account temporarily locked</p>
                  <p className="text-red-300 text-xs mt-0.5">Too many failed attempts. Try again in <span className="font-mono font-bold">{Math.floor(remaining / 60)}:{String(remaining % 60).padStart(2, '0')}</span></p>
                </div>
              </div>
            )}

            {/* Attempts warning */}
            {!isLocked && attempts > 0 && attempts < ADMIN_MAX_ATTEMPTS && (
              <div className="mb-6 rounded-xl p-3 border border-yellow-500 border-opacity-30 flex items-center gap-2"
                style={{ background: 'rgba(234,179,8,0.08)' }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-yellow-400 flex-shrink-0" viewBox="0 0 24 24" fill="currentColor">
                  <path fillRule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clipRule="evenodd" />
                </svg>
                <p className="text-yellow-300 text-xs">Invalid credentials — <span className="font-bold">{attemptsLeft}</span> attempt{attemptsLeft !== 1 ? 's' : ''} remaining</p>
              </div>
            )}

            {/* Fields */}
            <div className="space-y-5">
              {/* Username */}
              <div>
                <label className="block text-xs font-semibold uppercase tracking-widest mb-2 text-purple-300">
                  Username
                </label>
                <div className={`relative rounded-xl transition-all duration-200 ${focused === 'username' ? 'ring-2 ring-purple-500 ring-opacity-60' : ''}`}
                  style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(139,92,246,0.25)' }}>
                  <div className="absolute left-4 top-1/2 -translate-y-1/2 text-purple-400">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                      <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <input
                    ref={usernameRef}
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    onFocus={() => setFocused('username')}
                    onBlur={() => setFocused('')}
                    onKeyDown={onKeyDown}
                    disabled={isLocked}
                    autoComplete="username"
                    placeholder="Enter username"
                    className="w-full pl-11 pr-4 py-3.5 bg-transparent text-white placeholder-gray-600 text-sm focus:outline-none disabled:opacity-40"
                    style={{ caretColor: '#a78bfa' }}
                  />
                </div>
              </div>

              {/* Password */}
              <div>
                <label className="block text-xs font-semibold uppercase tracking-widest mb-2 text-purple-300">
                  Password
                </label>
                <div className={`relative rounded-xl transition-all duration-200 ${focused === 'password' ? 'ring-2 ring-purple-500 ring-opacity-60' : ''}`}
                  style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(139,92,246,0.25)' }}>
                  <div className="absolute left-4 top-1/2 -translate-y-1/2 text-purple-400">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor">
                      <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3A5.25 5.25 0 0012 1.5zm-1.5 14.25a1.5 1.5 0 113 0v1.5a1.5 1.5 0 01-3 0v-1.5zm1.5-9a3.75 3.75 0 00-3.75 3.75v3h7.5v-3A3.75 3.75 0 0012 6.75z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <input
                    ref={passwordRef}
                    type={showPass ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onFocus={() => setFocused('password')}
                    onBlur={() => setFocused('')}
                    onKeyDown={onKeyDown}
                    disabled={isLocked}
                    autoComplete="current-password"
                    placeholder="Enter password"
                    className="w-full pl-11 pr-12 py-3.5 bg-transparent text-white placeholder-gray-600 text-sm focus:outline-none disabled:opacity-40"
                    style={{ caretColor: '#a78bfa' }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPass(v => !v)}
                    className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-purple-400 transition-colors"
                    tabIndex={-1}
                  >
                    {showPass ? (
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    )}
                  </button>
                </div>
                {capsLock && (
                  <p className="text-yellow-400 text-xs mt-1.5 flex items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-3 h-3" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.25a.75.75 0 01.75.75v.756a49.106 49.106 0 019.152 1 .75.75 0 01-.152 1.485h-1.918l2.474 10.124a.75.75 0 01-.375.84A6.723 6.723 0 0118.75 18a6.723 6.723 0 01-3.181-.795.75.75 0 01-.375-.84l2.474-10.124H12.75V21a.75.75 0 01-1.5 0V6.241h-4.662l2.474 10.124a.75.75 0 01-.375.84A6.723 6.723 0 015.25 18a6.723 6.723 0 01-3.181-.795.75.75 0 01-.375-.84L4.168 6.241H2.25a.75.75 0 01-.152-1.485 49.105 49.105 0 019.152-1V3a.75.75 0 01.75-.75z"/></svg>
                    Caps Lock is on
                  </p>
                )}
              </div>

              {/* Submit */}
              <button
                onClick={onSubmit}
                disabled={isLocked}
                className="w-full mt-2 py-3.5 rounded-xl font-bold text-sm tracking-wider uppercase transition-all duration-300 disabled:opacity-40 disabled:cursor-not-allowed relative overflow-hidden group"
                style={{
                  background: isLocked ? 'rgba(124,58,237,0.2)' : 'linear-gradient(135deg, #7C3AED, #F97316)',
                  boxShadow: isLocked ? 'none' : '0 0 30px rgba(124,58,237,0.4)'
                }}
              >
                <span className="relative z-10 text-white flex items-center justify-center gap-2">
                  {isLocked ? (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor"><path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3A5.25 5.25 0 0012 1.5zm0 9a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0112 10.5z" clipRule="evenodd"/></svg>
                      Locked
                    </>
                  ) : 'Access Dashboard'}
                </span>
                {!isLocked && <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300" />}
              </button>
            </div>

            {/* Footer */}
            <div className="mt-8 pt-6 border-t border-white border-opacity-5 text-center">
              <p className="text-xs text-gray-600">
                This portal is for authorized personnel only.<br />
                All access attempts are logged.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom label */}
        <p className="text-center text-xs text-gray-700 mt-4">
          Mamu's Sweet House © 2025 · Admin v2.0
        </p>
      </div>

      <style>{`
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          15% { transform: translateX(-8px); }
          30% { transform: translateX(8px); }
          45% { transform: translateX(-6px); }
          60% { transform: translateX(6px); }
          75% { transform: translateX(-4px); }
          90% { transform: translateX(4px); }
        }
        .animate-shake { animation: shake 0.6s ease-in-out; }
      `}</style>
    </div>
  );
};
const App = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cart, setCart] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [orders, setOrders] = useState([]);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [paymentLoading, setPaymentLoading] = useState(false);

  const heroSlides = [
    { title: "Uttrakhand Delicacy", subtitle: "Traditional Himalayan Sweets", image: "https://images.squarespace-cdn.com/content/v1/578753d7d482e9c3a909de40/1714652159914-Q3NK9X2LPRZ63KGMG6ZP/bal+mithai.jpg?format=2500w", color: "#F4F3EE" }, { title: "Now Taste The Authentic", subtitle: "With Online Delivery Service", image: "https://tehrigarhwal.com/wp-content/uploads/2025/09/Dry-Fruit-Bal-mithai-1024x828.jpg", color: "#C3A375" },
    {
      title: "Serving Customers Since 1940",
      subtitle: "Premium Balmithai & Traditional Sweets",
      image: "https://imgs.search.brave.com/BisjS_eZumjFPP84Q7x3Pepv32ngIFWl_CAOQKXoKEc/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly93d3cu/aG90ZWxiaGFudXBh/bGFjZS5jb20vcnVk/cmFwcmF5YWcvd3At/Y29udGVudC91cGxv/YWRzLzIwMjQvMDcv/c2luZ29yaS0yLmpw/Zw",
      color: "#e2efeb"
    },
    {
      title: "Express Delivery",
      subtitle: "Get Your Order in Less Than 4 Days",
      image: "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1200&h=800&fit=crop",
      color: "#F59E0B"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const addToCart = (item, quantity) => {
    if (quantity > 0) {
      setCart(prev => {
        const existing = prev.find(i => i.name === item);
        if (existing) {
          return prev.map(i => i.name === item ? { ...i, quantity: i.quantity + quantity } : i);
        }
        return [...prev, { name: item, quantity, price: 440 }];
      });
    }
  };

  const removeFromCart = (itemName) => {
    setCart(prev => prev.filter(item => item.name !== itemName));
  };

//   const handleLogin = () => {
//   if (username === 'admin' && password === 'mamus@1940') {
//     setIsLoggedIn(true);
//     setCurrentPage('dashboard');
//   }
//   // Don't alert here — AdminLogin handles the error UI itself now
// };

const handleLogin = async () => {
  try {
    const res = await fetch(`${BACKEND_URL}/api/admin/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ username, password })
    });

    const data = await res.json();

    if (data.success) {
      localStorage.setItem("adminToken", data.token);
      setIsLoggedIn(true);
      setCurrentPage("dashboard");
    } else {
      alert("Invalid credentials");
    }
  } catch (err) {
    console.error(err);
    alert("Server error");
  }
};

  // ─── RAZORPAY PAYMENT HANDLER ────────────────────────────────────────────────
  const handlePlaceOrder = async () => {
    if (cart.length === 0) return;

    const subtotal = cart.reduce((sum, item) => sum + item.quantity * item.price, 0);
    const totalKg = cart.reduce((sum, item) => sum + item.quantity, 0);
    const total = subtotal + totalKg * 100;

    setPaymentLoading(true);

    try {
      // 1. Create Razorpay order on backend
      const res = await fetch(`${BACKEND_URL}/api/payment/create-order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ amount: total }),
      });

      if (!res.ok) throw new Error('Backend order creation failed');
      const { order } = await res.json();

      // 2. Open Razorpay checkout modal
      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: order.amount,
        currency: 'INR',
        name: "Mamu's Sweet House",
        description: 'Traditional Uttarakhand Sweets',
        order_id: order.id,

        handler: async function (response) {
          try {
            // 3. Verify payment signature on backend
            const verifyRes = await fetch(`${BACKEND_URL}/api/payment/verify`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(response),
            });
            const verifyData = await verifyRes.json();

            if (verifyData.success) {
              const newOrder = {
                id: order.id,
                items: [...cart],
                total,
                date: new Date().toLocaleString(),
                paymentMethod: 'Razorpay',
                paymentId: response.razorpay_payment_id,
              };
              setOrders(prev => [newOrder, ...prev]);
              setCart([]);
              alert(`✅ Payment Successful!\nPayment ID: ${response.razorpay_payment_id}\nYour order is confirmed! We will dispatch within 24 hours.`);
            } else {
              alert('❌ Payment verification failed. Please contact us on WhatsApp: +91 9027673285');
            }
          } catch {
            alert('Verification error. Please contact us with your payment ID.');
          }
        },

        prefill: { name: '', email: '', contact: '' },
        theme: { color: '#7C3AED' },
        modal: {
          ondismiss: () => {
            setPaymentLoading(false);
          },
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', function () {
        alert('❌ Payment failed. Please try again or contact support.');
        setPaymentLoading(false);
      });
      rzp.open();
    } catch (err) {
      console.error(err);
      alert('Something went wrong connecting to payment gateway. Please try again.');
    } finally {
      setPaymentLoading(false);
    }
  };
  // ─────────────────────────────────────────────────────────────────────────────

  const HomePage = () => {
    const [isVisible, setIsVisible] = useState(false);
    useEffect(() => { setIsVisible(true); }, []);

    return (
      <div className="min-h-screen bg-gradient-to-b from-purple-50 via-blue-50 to-orange-50">
        <div className="relative h-screen overflow-hidden">
          {heroSlides.map((slide, idx) => (
            <div
              key={idx}
              className="absolute inset-0 transition-opacity duration-1000"
              style={{ opacity: currentSlide === idx ? 1 : 0, zIndex: currentSlide === idx ? 1 : 0 }}
            >
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${slide.image})`, filter: 'brightness(0.6)' }}
              />
              <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, ${slide.color}40 0%, ${slide.color}20 100%)` }} />
              <div className="relative z-10 flex flex-col items-center justify-center h-full text-white px-4">
                <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-center mb-4 animate-fadeIn" style={{ color: slide.color, textShadow: '2px 2px 4px rgba(0,0,0,0.3)' }}>
                  {slide.title}
                </h1>
                <p className="text-xl sm:text-2xl md:text-3xl text-center mb-8 animate-fadeIn">{slide.subtitle}</p>
                <button
                  onClick={() => setCurrentPage('order')}
                  className="bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-bold py-3 sm:py-4 px-6 sm:px-8 rounded-full text-lg sm:text-xl transition-all transform hover:scale-105 shadow-2xl"
                >
                  Order Now
                </button>
              </div>
            </div>
          ))}
          <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 z-20">
            {heroSlides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrentSlide(idx)}
                className={`w-3 h-3 rounded-full transition-all ${currentSlide === idx ? 'bg-white w-8' : 'bg-white bg-opacity-50'}`}
              />
            ))}
          </div>
        </div>

        <div className="py-16 sm:py-20 px-4 bg-gradient-to-r from-purple-100 via-blue-100 to-orange-100">
          <div className="max-w-7xl mx-auto">
            <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
              <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-center mb-4 text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic', textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>
                Mero Pahad
              </h2>
              <p className="text-center text-lg sm:text-xl text-gray-700 mb-12 max-w-3xl mx-auto">
                The Sweet Heritage of Uttarakhand Mountains
              </p>
            </div>
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500 hover:shadow-purple-300 relative">
                <img src="https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?w=800&h=600&fit=crop" alt="Uttarakhand Mountains" className="w-full h-64 sm:h-80 object-cover hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-purple-900 via-transparent to-transparent opacity-0 hover:opacity-70 transition-opacity duration-500 flex items-end p-6">
                  <p className="text-white font-bold text-xl">Majestic Himalayas</p>
                </div>
              </div>
              <div className="rounded-2xl overflow-hidden shadow-2xl transform hover:scale-105 transition-transform duration-500 hover:shadow-blue-300 relative">
                <img src="https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=800&h=600&fit=crop" alt="Nainital Lake" className="w-full h-64 sm:h-80 object-cover hover:scale-110 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-blue-900 via-transparent to-transparent opacity-0 hover:opacity-70 transition-opacity duration-500 flex items-end p-6">
                  <p className="text-white font-bold text-xl">Serene Nainital</p>
                </div>
              </div>
            </div>
            <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-2xl p-6 sm:p-10 hover:shadow-purple-200 transition-shadow duration-500">
              <p className="text-base sm:text-lg text-gray-800 leading-relaxed mb-6">
                Nestled in the serene valleys of Uttarakhand, our sweets carry the essence of the mighty Himalayas. <strong className="text-purple-700">Balmithai</strong>, the crown jewel of Kumaoni cuisine, is a delicate sweet made with pure khoya and desi ghee, wrapped in a crispy outer layer that melts in your mouth.
              </p>
              <p className="text-base sm:text-lg text-gray-800 leading-relaxed mb-6">
                <strong className="text-blue-700">Singori</strong>, another treasure from these mountains, is a traditional sweet wrapped in maalu leaves, filled with khoya and coconut - a taste that transports you to the pine forests of Uttarakhand.
              </p>
              <p className="text-base sm:text-lg text-gray-800 leading-relaxed">
                Our handcrafted <strong className="text-orange-700">chocolates</strong> blend the richness of traditional methods with contemporary flavors, creating a unique fusion that honors our heritage while embracing innovation.
              </p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-orange-400 to-purple-500 text-white py-12 sm:py-16 px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white bg-opacity-20 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl transform hover:scale-105 transition-transform">
                <Phone className="w-10 h-10 sm:w-12 sm:h-12 mb-4 mx-auto" />
                <h3 className="text-lg sm:text-xl font-bold mb-2 text-center">Call Us</h3>
                <p className="text-base sm:text-lg text-center">9027673111</p>
                <p className="text-xs sm:text-sm text-center mt-2 opacity-90">Mon-Sat: 9AM-8PM</p>
              </div>
              <div className="bg-white bg-opacity-20 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl transform hover:scale-105 transition-transform">
                <Mail className="w-10 h-10 sm:w-12 sm:h-12 mb-4 mx-auto" />
                <h3 className="text-lg sm:text-xl font-bold mb-2 text-center">Email Us</h3>
                <p className="text-sm sm:text-base text-center break-all">mamussweet@gmail.com</p>
                <p className="text-xs sm:text-sm text-center mt-2 opacity-90">Quick Response</p>
              </div>
              <div className="bg-white bg-opacity-20 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl transform hover:scale-105 transition-transform">
                <MapPin className="w-10 h-10 sm:w-12 sm:h-12 mb-4 mx-auto" />
                <h3 className="text-lg sm:text-xl font-bold mb-2 text-center">Visit Us</h3>
                <p className="text-base sm:text-lg text-center">Nainital</p>
                <p className="text-sm sm:text-base text-center">Uttarakhand, India</p>
                <a href="https://maps.app.goo.gl/9U4LHWDNCbwgyE9f8" target="_blank" rel="noopener noreferrer" className="inline-block mt-3 bg-white text-purple-700 px-4 py-2 rounded-full font-semibold hover:bg-purple-100 transition-colors text-sm">
                  View Map
                </a>
              </div>
              <div className="bg-white bg-opacity-20 backdrop-blur-md rounded-2xl p-6 sm:p-8 shadow-xl transform hover:scale-105 transition-transform">
                <ShoppingCart className="w-10 h-10 sm:w-12 sm:h-12 mb-4 mx-auto" />
                <h3 className="text-lg sm:text-xl font-bold mb-2 text-center">Express Delivery</h3>
                <p className="text-base sm:text-lg text-center">Pan India</p>
                <p className="text-xs sm:text-sm text-center mt-2 opacity-90">Within 4 Days</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const AboutPage = () => (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 via-blue-50 to-orange-50 py-12 sm:py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-center mb-12 sm:mb-16 text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
          About Us
        </h1>
        <div className="grid md:grid-cols-2 gap-8 sm:gap-12 items-center mb-12 sm:mb-16">
          <div className="rounded-2xl overflow-hidden shadow-2xl order-2 md:order-1">
            <img src="https://images.unsplash.com/photo-1605649487212-47bdab064df7?w=800&h=600&fit=crop" alt="Nainital Lake" className="w-full h-64 sm:h-96 object-cover" />
          </div>
          <div className="space-y-4 sm:space-y-6 order-1 md:order-2">
            <p className="text-lg sm:text-xl text-gray-700 leading-relaxed">
              <strong className="text-2xl sm:text-3xl text-purple-800" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Mamu's Sweet House</strong> has been a cornerstone of Uttarakhand's culinary heritage since <strong>1940</strong>. For over eight decades, we have been crafting authentic traditional sweets.
            </p>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed">
              Our journey began in the picturesque hills of Nainital, where our founder started with a simple vision: to preserve and share the authentic taste of Uttarakhand sweets with the world.
            </p>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          <div className="bg-white bg-opacity-70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl">
            <h3 className="text-xl sm:text-2xl font-bold text-orange-700 mb-4">Our Specialties</h3>
            <ul className="space-y-2 text-gray-700 text-sm sm:text-base">
              <li className="flex items-start"><span className="text-orange-500 mr-2 text-lg">•</span><span>Authentic Balmithai made with pure desi ghee</span></li>
              <li className="flex items-start"><span className="text-orange-500 mr-2 text-lg">•</span><span>Traditional Singori wrapped in maalu leaves</span></li>
              <li className="flex items-start"><span className="text-orange-500 mr-2 text-lg">•</span><span>Handcrafted Uttarakhand chocolates</span></li>
            </ul>
          </div>
          <div className="bg-white bg-opacity-70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl">
            <h3 className="text-xl sm:text-2xl font-bold text-purple-700 mb-4">Our Promise</h3>
            <p className="text-gray-700 leading-relaxed text-sm sm:text-base">We use only the finest ingredients sourced locally from Uttarakhand. Every sweet is prepared using traditional methods and pure desi ghee.</p>
          </div>
          <div className="bg-white bg-opacity-70 backdrop-blur-sm p-6 sm:p-8 rounded-2xl shadow-xl">
            <h3 className="text-xl sm:text-2xl font-bold text-blue-700 mb-4">Our Reputation</h3>
            <p className="text-gray-700 leading-relaxed text-sm sm:text-base">Known throughout Uttarakhand and beyond, Mamu's Sweet House has earned a respected name for quality, authenticity, and exceptional taste.</p>
          </div>
        </div>
        <div className="bg-gradient-to-r from-purple-200 to-orange-200 p-8 sm:p-10 rounded-3xl shadow-2xl text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-purple-900 mb-4">Experience the Taste of Tradition</h3>
          <p className="text-lg sm:text-xl text-gray-700 mb-6">From the heart of the Himalayas to your doorstep</p>
          <button onClick={() => setCurrentPage('order')} className="bg-gradient-to-r from-orange-400 to-orange-500 hover:from-orange-500 hover:to-orange-600 text-white font-bold py-3 px-8 rounded-full text-lg transition-all transform hover:scale-105 shadow-xl">
            Order Now
          </button>
        </div>
      </div>
    </div>
  );

  const OrderPage = () => {
    const [tempQuantity, setTempQuantity] = useState({ balmithai: 0, chocolate: 0 });
    const pricePerKg = 440;
    const deliveryChargePerKg = 100;
    const cartTotal = cart.reduce((sum, item) => sum + item.quantity * item.price, 0);
    const totalKg = cart.reduce((sum, item) => sum + item.quantity, 0);
    const deliveryCharges = totalKg * deliveryChargePerKg;
    const total = cartTotal + deliveryCharges;

    return (
      <div className="min-h-screen bg-gradient-to-b from-purple-50 via-blue-50 to-orange-50 py-12 sm:py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-bold text-center mb-8 sm:mb-12 text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
            Place Your Order
          </h1>

          <div className="grid lg:grid-cols-3 gap-6 sm:gap-8">
            {/* Products + Cart */}
            <div className="lg:col-span-2 space-y-6">
              <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 sm:p-8">
                <h2 className="text-2xl sm:text-3xl font-bold text-orange-800 mb-6">Our Products</h2>
                <div className="space-y-6">
                  {/* Balmithai */}
                  <div className="bg-gradient-to-r from-orange-100 to-purple-100 p-4 sm:p-6 rounded-2xl shadow-lg">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-purple-900">Balmithai</h3>
                        <p className="text-gray-600 text-sm sm:text-base">Traditional Kumaoni delicacy</p>
                        <p className="text-lg sm:text-xl font-bold text-orange-600 mt-2">₹{pricePerKg}/kg</p>
                      </div>
                      <div className="flex items-center gap-3 sm:gap-4">
                        <button onClick={() => setTempQuantity(prev => ({ ...prev, balmithai: Math.max(0, prev.balmithai - 0.5) }))} className="bg-purple-500 text-white w-10 h-10 rounded-full font-bold hover:bg-purple-600 shadow-lg">-</button>
                        <span className="text-xl sm:text-2xl font-bold w-16 sm:w-20 text-center">{tempQuantity.balmithai} kg</span>
                        <button onClick={() => setTempQuantity(prev => ({ ...prev, balmithai: prev.balmithai + 0.5 }))} className="bg-purple-500 text-white w-10 h-10 rounded-full font-bold hover:bg-purple-600 shadow-lg">+</button>
                        <button onClick={() => { addToCart('Balmithai', tempQuantity.balmithai); setTempQuantity(prev => ({ ...prev, balmithai: 0 })); }} className="bg-orange-500 hover:bg-orange-600 text-white px-4 sm:px-6 py-2 rounded-full font-bold shadow-lg ml-2">Add</button>
                      </div>
                    </div>
                  </div>

                  {/* Chocolate */}
                  <div className="bg-gradient-to-r from-purple-100 to-orange-100 p-4 sm:p-6 rounded-2xl shadow-lg">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                      <div className="flex-1">
                        <h3 className="text-xl sm:text-2xl font-bold text-purple-900">Chocolate</h3>
                        <p className="text-gray-600 text-sm sm:text-base">Handcrafted Uttarakhand style</p>
                        <p className="text-lg sm:text-xl font-bold text-orange-600 mt-2">₹{pricePerKg}/kg</p>
                      </div>
                      <div className="flex items-center gap-3 sm:gap-4">
                        <button onClick={() => setTempQuantity(prev => ({ ...prev, chocolate: Math.max(0, prev.chocolate - 0.5) }))} className="bg-purple-500 text-white w-10 h-10 rounded-full font-bold hover:bg-purple-600 shadow-lg">-</button>
                        <span className="text-xl sm:text-2xl font-bold w-16 sm:w-20 text-center">{tempQuantity.chocolate} kg</span>
                        <button onClick={() => setTempQuantity(prev => ({ ...prev, chocolate: prev.chocolate + 0.5 }))} className="bg-purple-500 text-white w-10 h-10 rounded-full font-bold hover:bg-purple-600 shadow-lg">+</button>
                        <button onClick={() => { addToCart('Chocolate', tempQuantity.chocolate); setTempQuantity(prev => ({ ...prev, chocolate: 0 })); }} className="bg-orange-500 hover:bg-orange-600 text-white px-4 sm:px-6 py-2 rounded-full font-bold shadow-lg ml-2">Add</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Cart */}
              {cart.length > 0 && (
                <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 sm:p-8">
                  <h2 className="text-2xl sm:text-3xl font-bold text-purple-800 mb-6 flex items-center">
                    <ShoppingCart className="mr-3" /> Your Cart
                  </h2>
                  <div className="space-y-4">
                    {cart.map((item, idx) => (
                      <div key={idx} className="flex flex-col sm:flex-row sm:items-center sm:justify-between bg-gradient-to-r from-purple-50 to-orange-50 p-4 rounded-xl gap-4">
                        <div className="flex-1">
                          <h3 className="text-lg sm:text-xl font-bold text-gray-800">{item.name}</h3>
                          <p className="text-gray-600 text-sm sm:text-base">{item.quantity} kg × ₹{item.price}</p>
                        </div>
                        <div className="flex items-center gap-3">
                          <span className="text-lg sm:text-xl font-bold text-orange-600">₹{item.quantity * item.price}</span>
                          <button onClick={() => removeFromCart(item.name)} className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-full shadow-lg">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3,6 5,6 21,6"/><path d="M19,6l-1,14H6L5,6"/><path d="M10,11v6"/><path d="M14,11v6"/><path d="M9,6V4h6v2"/></svg>
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Order Summary + Payment */}
            <div className="lg:col-span-1">
              <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 sm:p-8 sticky top-24">
                <h2 className="text-2xl sm:text-3xl font-bold text-purple-800 mb-6">Order Summary</h2>
                <div className="space-y-4 text-base sm:text-lg">
                  <div className="flex justify-between py-2 border-b border-gray-300">
                    <span className="text-gray-700">Subtotal:</span>
                    <span className="font-bold">₹{cartTotal}</span>
                  </div>
                  <div className="flex justify-between py-2 border-b border-gray-300">
                    <span className="text-gray-700">Delivery ({totalKg} kg):</span>
                    <span className="font-bold">₹{deliveryCharges}</span>
                  </div>
                  <div className="flex justify-between py-3 text-xl sm:text-2xl font-bold text-purple-900 border-t-2 border-purple-300">
                    <span>Total:</span>
                    <span>₹{total}</span>
                  </div>
                </div>

                {cart.length > 0 && (
                  <div className="mt-8">
                    {/* Razorpay info badge */}
                    <div className="bg-gradient-to-r from-purple-50 to-blue-50 border-2 border-purple-200 rounded-2xl p-4 mb-6">
                      <div className="flex items-center gap-3 mb-2">
                        <CreditCard className="w-6 h-6 text-purple-600 flex-shrink-0" />
                        <span className="font-bold text-purple-900 text-base">Secure Payment via Razorpay</span>
                      </div>
                      <p className="text-sm text-gray-600">Pay using UPI, Credit/Debit Card, Net Banking or Wallets. 100% secure &amp; encrypted.</p>
                      <div className="flex gap-2 mt-3 flex-wrap">
                        {['UPI', 'Visa', 'Mastercard', 'RuPay', 'Wallets'].map(m => (
                          <span key={m} className="bg-white border border-purple-200 text-purple-700 text-xs font-semibold px-2 py-1 rounded-lg">{m}</span>
                        ))}
                      </div>
                    </div>

                    {/* Pay button */}
                    <button
                      disabled={cart.length === 0 || paymentLoading}
                      onClick={handlePlaceOrder}
                      className={`w-full font-bold py-4 px-8 rounded-full text-lg transition-all transform shadow-xl flex items-center justify-center gap-3 ${
                        cart.length > 0 && !paymentLoading
                          ? 'bg-gradient-to-r from-orange-400 to-purple-500 hover:from-orange-500 hover:to-purple-600 text-white hover:scale-105 hover:shadow-2xl'
                          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                      }`}
                    >
                      {paymentLoading ? (
                        <>
                          <svg className="animate-spin w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                          </svg>
                          Connecting...
                        </>
                      ) : (
                        <>🔒 Pay ₹{total} with Razorpay</>
                      )}
                    </button>

                    <p className="text-xs text-gray-500 text-center mt-3">
                      After payment, order confirmation will appear instantly.
                    </p>
                  </div>
                )}

                {cart.length === 0 && (
                  <div className="mt-6 text-center py-6">
                    <ShoppingCart className="w-12 h-12 mx-auto text-gray-300 mb-3" />
                    <p className="text-gray-500 font-semibold">Your cart is empty</p>
                    <p className="text-gray-400 text-sm mt-1">Add items from the left to get started</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // const AdminLogin = () => (
  //   <div className="min-h-screen bg-gradient-to-b from-orange-50 via-blue-50 to-purple-50 py-20 px-4">
  //     <div className="max-w-md mx-auto">
  //       <div className="bg-white bg-opacity-80 backdrop-blur-sm rounded-3xl shadow-2xl p-8 sm:p-10">
  //         <div className="flex justify-center mb-6"><Logo className="w-24 h-24" /></div>
  //         <h1 className="text-3xl sm:text-4xl font-bold text-center mb-8 text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Admin Login</h1>
  //         <div className="space-y-6">
  //           <div>
  //             <label className="block text-gray-700 font-bold mb-2 text-lg">Username</label>
  //             <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:outline-none bg-white" placeholder="Enter username" />
  //           </div>
  //           <div>
  //             <label className="block text-gray-700 font-bold mb-2 text-lg">Password</label>
  //             <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleLogin()} className="w-full px-4 py-3 border-2 border-purple-200 rounded-xl focus:border-purple-500 focus:outline-none bg-white" placeholder="Enter password" />
  //           </div>
  //           <button onClick={handleLogin} className="w-full bg-gradient-to-r from-orange-400 to-purple-500 hover:from-orange-500 hover:to-purple-600 text-white font-bold py-4 px-6 rounded-xl transition-all transform hover:scale-105 shadow-xl text-lg">
  //             Login
  //           </button>
  //           <div className="bg-blue-50 border-2 border-blue-200 rounded-xl p-4 mt-4">
  //             <p className="text-sm text-gray-700 text-center">
  //               <strong className="text-blue-900">Default Login:</strong><br />
  //               Username: <span className="font-mono bg-white px-2 py-1 rounded">admin</span><br />
  //               Password: <span className="font-mono bg-white px-2 py-1 rounded">mamus@1940</span>
  //             </p>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );

  const AdminDashboard = () => (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 via-blue-50 to-orange-50 py-12 sm:py-20 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-4xl sm:text-5xl font-bold text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Admin Dashboard</h1>
          <button onClick={() => { setIsLoggedIn(false); setCurrentPage('home'); setUsername(''); setPassword(''); }} className="bg-red-500 hover:bg-red-600 text-white px-6 py-2 rounded-full font-semibold transition-all shadow-lg">
            Logout
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 border-2 border-purple-200">
            <div className="flex items-center justify-between">
              <div><p className="text-gray-600 text-sm font-semibold">Total Orders</p><p className="text-4xl font-bold text-purple-900">{orders.length}</p></div>
              <ShoppingCart className="w-12 h-12 text-purple-500" />
            </div>
          </div>
          <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 border-2 border-orange-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm font-semibold">Orders Today</p>
                <p className="text-4xl font-bold text-orange-900">
                  {orders.filter(o => new Date(o.date).toDateString() === new Date().toDateString()).length}
                </p>
              </div>
              <Mail className="w-12 h-12 text-orange-500" />
            </div>
          </div>
          <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 border-2 border-green-200">
            <div className="flex items-center justify-between">
              <div><p className="text-gray-600 text-sm font-semibold">Total Revenue</p><p className="text-3xl font-bold text-green-900">₹{orders.reduce((sum, o) => sum + o.total, 0)}</p></div>
              <CreditCard className="w-12 h-12 text-green-500" />
            </div>
          </div>
        </div>

        <div className="bg-white bg-opacity-70 backdrop-blur-sm rounded-3xl shadow-xl p-6 sm:p-8 border-2 border-purple-200">
          <h2 className="text-2xl sm:text-3xl font-bold text-purple-800 mb-6">Recent Orders</h2>
          {orders.length === 0 ? (
            <div className="text-center py-12">
              <ShoppingCart className="w-16 h-16 mx-auto text-gray-400 mb-4" />
              <p className="text-xl text-gray-600 font-semibold">No orders yet</p>
              <p className="text-gray-500 mt-2">Orders will appear here once customers pay via Razorpay</p>
            </div>
          ) : (
            <div className="space-y-4">
              {orders.map((order) => (
                <div key={order.id} className="bg-gradient-to-r from-purple-50 to-orange-50 p-6 rounded-2xl border-2 border-purple-200 shadow-md">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
                    <div>
                      <p className="text-sm text-gray-600 font-semibold">Order ID: #{String(order.id).slice(-8)}</p>
                      <p className="text-sm text-gray-600">{order.date}</p>
                      {order.paymentId && <p className="text-xs text-green-700 font-mono mt-1">Payment: {order.paymentId}</p>}
                    </div>
                    <div className="text-right">
                      <p className="text-2xl font-bold text-purple-900">₹{order.total}</p>
                      <span className="inline-block bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full mt-1">{order.paymentMethod} ✓</span>
                    </div>
                  </div>
                  <div className="border-t-2 border-purple-300 pt-4">
                    <p className="font-semibold text-gray-700 mb-2">Items:</p>
                    {order.items.map((item, idx) => (
                      <div key={idx} className="flex justify-between items-center py-1">
                        <span className="text-gray-700">{item.name} ({item.quantity} kg)</span>
                        <span className="font-semibold text-gray-800">₹{item.quantity * item.price}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-white">
      <header className="bg-white shadow-lg sticky top-0 z-50 border-b-2 border-purple-200 backdrop-blur-md bg-opacity-95">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex gap-4 sm:gap-6 flex-1">
              <button onClick={() => setCurrentPage('order')} className="text-gray-700 hover:text-orange-600 font-semibold transition-all duration-300 text-sm sm:text-base relative group">
                Place Order
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-orange-600 group-hover:w-full transition-all duration-300"></span>
              </button>
              <button onClick={() => setCurrentPage('about')} className="text-gray-700 hover:text-purple-600 font-semibold transition-all duration-300 text-sm sm:text-base relative group">
                About Us
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-600 group-hover:w-full transition-all duration-300"></span>
              </button>
            </div>

            <div onClick={() => setCurrentPage('home')} className="flex items-center gap-2 sm:gap-3 cursor-pointer transform hover:scale-105 transition-transform duration-300">
              <Logo className="w-12 h-12 sm:w-16 sm:h-16" />
              <span className="text-xl sm:text-2xl md:text-3xl font-bold text-purple-900" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>
                Mamu's Sweet House
              </span>
            </div>

            <div className="flex gap-4 sm:gap-6 flex-1 justify-end">
              <button onClick={() => setCurrentPage('home')} className={`font-semibold transition-all duration-300 text-sm sm:text-base relative group ${currentPage === 'home' ? 'text-orange-600' : 'text-gray-700 hover:text-orange-600'}`}>
                Home
                <span className={`absolute bottom-0 left-0 h-0.5 bg-orange-600 transition-all duration-300 ${currentPage === 'home' ? 'w-full' : 'w-0 group-hover:w-full'}`}></span>
              </button>
              <button onClick={() => setCurrentPage('admin')} className="text-gray-700 hover:text-purple-600 font-semibold transition-all duration-300 text-sm sm:text-base relative group">
                Admin
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-purple-600 group-hover:w-full transition-all duration-300"></span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {currentPage === 'home' && <HomePage />}
      {currentPage === 'about' && <AboutPage />}
      {currentPage === 'order' && <OrderPage />}
      {currentPage === 'admin' && !isLoggedIn && (
  <AdminLogin
    username={username}
    setUsername={setUsername}
    password={password}
    setPassword={setPassword}
    handleLogin={handleLogin}
  />
)}
      {currentPage === 'dashboard' && isLoggedIn && <AdminDashboard />}

      <footer className="bg-gradient-to-r from-purple-900 to-orange-800 text-white py-8 px-4">
        <div className="max-w-6xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Logo className="w-12 h-12" />
            <span className="text-2xl font-bold" style={{ fontFamily: 'Georgia, serif', fontStyle: 'italic' }}>Mamu's Sweet House</span>
          </div>
          <p className="text-lg mb-2">Traditional Uttarakhand Sweets Since 1940</p>
          <p className="text-sm opacity-80">© 2025 Mamu's Sweet House. All rights reserved.</p>
        </div>
      </footer>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn { animation: fadeIn 1s ease-out; }
        input:focus { box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.1); }
        button:active { transform: scale(0.97); }
      `}</style>
    </div>
  );
};

export default App;